"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBloodGroup = createBloodGroup;
const events_1 = require("../../../events");
const bloodGroup_1 = require("../../../forms/htx/bloodGroup");
const queries_1 = require("../queries");
function createBloodGroup({ formatMessageMap }, { events }) {
    const event1 = (0, events_1.findLastEventByQuery)(events, queries_1.queries.vAb0);
    const event2 = (0, events_1.findLastEventByQuery)(events, queries_1.queries.vRh);
    if (event1 === undefined || event2 === undefined) {
        return { value: "-" };
    }
    const s1 = formatMessageMap(bloodGroup_1.ab0Messages, event1.value);
    const s2 = formatMessageMap(bloodGroup_1.rhMessages, event2.value);
    return {
        value: `${s1} RH ${s2}`,
        timestamp: event1.timestamp,
        origin: event1.origin
    };
}
